module.exports = __webpack_public_path__ + "img/Mavi.30377252.jpeg";